import { z } from "zod";
import {
  ControlDataTypeKey,
  Types
} from "../prop-controllers";
import { P, match } from "ts-pattern";
const tableIdSchema = z.string();
const tablePropControllerDataV0Schema = tableIdSchema;
const TablePropControllerDataV1Type = "prop-controllers::table::v1";
const tablePropControllerDataV1Schema = z.object({
  [ControlDataTypeKey]: z.literal(TablePropControllerDataV1Type),
  value: tableIdSchema
});
const tablePropControllerDataSchema = z.union([
  tablePropControllerDataV0Schema,
  tablePropControllerDataV1Schema
]);
function Table(options = {}) {
  return { type: Types.Table, version: 1, options };
}
function getTablePropControllerDataTableId(data) {
  return match(data).with(
    { [ControlDataTypeKey]: TablePropControllerDataV1Type },
    (v1) => v1.value
  ).otherwise((v0) => v0);
}
function createTablePropControllerDataFromTableId(value, definition) {
  return match(definition).with(
    { version: 1 },
    P.nullish,
    () => ({
      [ControlDataTypeKey]: TablePropControllerDataV1Type,
      value
    })
  ).otherwise(() => value);
}
function copyTableId(data, context) {
  if (data == null)
    return data;
  return context.replacementContext.tableIds.get(data) ?? data;
}
function copyTablePropControllerData(data, context) {
  return match(data).with(void 0, () => void 0).with(
    { [ControlDataTypeKey]: TablePropControllerDataV1Type },
    (v1) => ({
      [ControlDataTypeKey]: TablePropControllerDataV1Type,
      value: copyTableId(v1.value, context)
    })
  ).otherwise((v0) => copyTableId(v0, context));
}
function getTablePropControllerDataTableIds(data) {
  const value = getTablePropControllerDataTableId(data);
  return value ? [value] : [];
}
export {
  Table,
  TablePropControllerDataV1Type,
  copyTablePropControllerData,
  createTablePropControllerDataFromTableId,
  getTablePropControllerDataTableId,
  getTablePropControllerDataTableIds,
  tablePropControllerDataSchema
};
//# sourceMappingURL=table.js.map